<script setup lang="ts">
import { ViewModeType } from "~/classes/generated/interface"

const { state: viewModeState } = useViewMode()
const { mainViewTestId } = useTestId()
</script>

<template>
  <div
    class="collection-view"
    :data-testid="mainViewTestId"
  >
    <collection-icon-view v-if="viewModeState.current.mode === ViewModeType.Icon" />
    <collection-grid-view v-else-if="viewModeState.current.mode === ViewModeType.Grid" />
    <collection-feed-view v-else-if="viewModeState.current.mode === ViewModeType.Feed" />
    <collection-detail-view v-else-if="viewModeState.current.mode === ViewModeType.Detail" />
    <collection-table-view v-else-if="viewModeState.current.mode === ViewModeType.Table" />
    <collection-tree-view v-else-if="viewModeState.current.mode === ViewModeType.Tree" />
    <collection-column-view v-else-if="viewModeState.current.mode === ViewModeType.Column" />
    <collection-gallery-view v-else-if="viewModeState.current.mode === ViewModeType.Gallery" />
    <div v-else>
      Something went wrong...
    </div>
    <collection-footer-view />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.collection-view
  @apply h-full w-full overflow-hidden
</style>
